
export const saveLocal = (key, value, expire) => {
  setCookie(key, value, expire);
  localStorage.setItem(key, value);
};

export const getLocal = (key) => {
  return localStorage.getItem(key) || getCookie(key);
};

export const deleteLocal = (key) => {
  delete_cookie(key);
  localStorage.removeItem(key)
};

export const delete_cookie = (name) => {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(exdays);
  const expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export const getCookie = (cname) => {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
